export const phoneMaxWidth = "600px";
export const padMaxWidth = "1200px";
